import { defineMessages } from 'react-intl-next';

export const messages: {
	defaultPlaceholderText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'company-hub.search-extension.manifest.macro-title',
		defaultMessage: 'Custom search',
		description:
			'Title of company hub search macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	description: {
		id: 'company-hub.search-extension.manifest.macro-description',
		defaultMessage: 'Add a filtered search bar',
		description:
			'Description of company hub search macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	defaultPlaceholderText: {
		id: 'company-hub.search-extension.manifest.default-placeholder-text',
		defaultMessage: 'Search for verified announcements, resources, and policies',
		description: 'Default placeholder text for company hub search macro.',
	},
});
